import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  key: 0,
  class: "mt-3 d-flex align-center flex-wrap ga-2"
}
const _hoisted_4 = { class: "mt-4 d-flex align-center" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-center mr-3"
}
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { style: {"width":"48px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = {
  key: 0,
  class: "text-caption text-grey-darken-1"
}
const _hoisted_12 = {
  key: 0,
  class: "deadline-overdue"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "text-caption text-grey-darken-1 mt-1"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "text-caption text-error mt-1"
}
const _hoisted_18 = {
  key: 1,
  class: "text-caption text-error mt-1"
}
const _hoisted_19 = {
  key: 2,
  class: "text-caption text-grey-darken-1 mt-1"
}
const _hoisted_20 = { class: "tp-period-range" }
const _hoisted_21 = {
  key: 0,
  class: "text-caption text-error mt-1"
}
const _hoisted_22 = {
  key: 0,
  class: "text-caption text-error mt-1"
}
const _hoisted_23 = {
  key: 1,
  class: "text-caption text-grey-darken-1 mt-1"
}
const _hoisted_24 = {
  key: 0,
  class: "text-caption text-error mt-1"
}
const _hoisted_25 = {
  key: 1,
  class: "text-caption text-grey-darken-1 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[23] || (_cache[23] = _createElementVNode("div", null, [
        _createElementVNode("h2", null, "指導計画"),
        _createElementVNode("div", { class: "text-caption text-grey-darken-1 mt-1" }, " 作成・提出・承認状況の確認からExcel出力まで、この画面で行います。 ")
      ], -1)),
      _createVNode(_component_v_spacer),
      (_ctx.canManageSetting)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            onClick: _ctx.openSetting,
            class: "mr-2",
            color: "primary",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode("mdi-cog", -1)
                ]))]),
                _: 1
              }),
              _cache[20] || (_cache[20] = _createTextVNode(" 帳票設定 ", -1))
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_btn, {
        onClick: _ctx.openCreateDialog,
        color: "primary",
        variant: "flat"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[22] || (_cache[22] = _createTextVNode(" 新規作成 ", -1))
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      color: "primary",
      class: "mt-4",
      disabled: _ctx.loading
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusTabs, (statusTab) => {
          return (_openBlock(), _createBlock(_component_v_tab, {
            key: statusTab.value,
            value: statusTab.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(statusTab.title) + " ", 1),
              _createVNode(_component_v_chip, {
                class: "ml-2",
                size: "x-small",
                variant: "flat",
                color: "grey-lighten-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.statusCount(statusTab.countKey)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-4 pa-2",
      color: "grey-lighten-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilters.keyword,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.keyword) = $event)),
                      label: "帳票名・クラス・作成者で検索",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      color: "primary",
                      disabled: _ctx.loading,
                      onKeyup: _withKeys(_ctx.searchFromFirstPage, ["enter"])
                    }, null, 8, ["modelValue", "disabled", "onKeyup"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.planType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.planType) = $event)),
                      items: _ctx.planTypeItems,
                      label: "帳票種別",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary",
                      disabled: _ctx.loading
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.classId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.classId) = $event)),
                      items: _ctx.classItems,
                      label: "クラス",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary",
                      disabled: _ctx.loading
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.businessYear,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.businessYear) = $event)),
                      items: _ctx.businessYearItems,
                      label: "年度",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary",
                      disabled: _ctx.loading
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.authorUserNurseryId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.authorUserNurseryId) = $event)),
                      items: _ctx.authorItems,
                      label: "作成者",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary",
                      disabled: _ctx.loading
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.searchFromFirstPage,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode(" 検索 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.appliedFilters.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilters, (applied) => {
            return (_openBlock(), _createBlock(_component_v_chip, {
              key: applied.key,
              closable: "",
              size: "small",
              variant: "outlined",
              color: "primary",
              "onClick:close": ($event: any) => (_ctx.clearFilter(applied.key))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(applied.label), 1)
              ]),
              _: 2
            }, 1032, ["onClick:close"]))
          }), 128)),
          _createVNode(_component_v_btn, {
            onClick: _ctx.clearAllFilters,
            variant: "text",
            size: "small",
            color: "primary"
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode(" すべて解除 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h5", null, "計" + _toDisplayString(_ctx.listResponse ? _ctx.listResponse.count : 0) + "件", 1),
      _createVNode(_component_v_spacer),
      (_ctx.exportPolling)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              size: "18",
              width: "2",
              color: "primary",
              class: "mr-2"
            }),
            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Excelを作成しています...", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedPlanIds.length > 0)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            onClick: _ctx.bulkExportExcel,
            loading: _ctx.exporting,
            disabled: _ctx.exportPolling,
            color: "primary",
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createTextVNode("mdi-microsoft-excel", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" 選択した帳票をExcel出力（" + _toDisplayString(_ctx.selectedPlanIds.length) + "件） ", 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_7, [
                _createVNode(_component_v_checkbox, {
                  "model-value": _ctx.isAllSelected,
                  indeterminate: _ctx.isPartiallySelected,
                  "onUpdate:modelValue": _ctx.toggleSelectAll,
                  density: "compact",
                  "hide-details": "",
                  color: "primary"
                }, null, 8, ["model-value", "indeterminate", "onUpdate:modelValue"])
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("th", null, "帳票", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("th", null, "対象期間", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("th", null, "クラス", -1)),
              _cache[31] || (_cache[31] = _createElementVNode("th", null, "作成者", -1)),
              _cache[32] || (_cache[32] = _createElementVNode("th", null, "提出期限", -1)),
              _cache[33] || (_cache[33] = _createElementVNode("th", null, "コメント", -1)),
              _cache[34] || (_cache[34] = _createElementVNode("th", null, "版", -1)),
              _cache[35] || (_cache[35] = _createElementVNode("th", null, "ステータス", -1))
            ])
          ]),
          (_ctx.listResponse)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listResponse.data, (plan) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: plan.planId,
                    class: "teaching-plan-row",
                    onClick: ($event: any) => (_ctx.openPlan(plan.planId))
                  }, [
                    _createElementVNode("td", {
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode(_component_v_checkbox, {
                        "model-value": _ctx.selectedPlanIds.includes(plan.planId),
                        "onUpdate:modelValue": ($event: any) => (_ctx.toggleSelect(plan.planId)),
                        density: "compact",
                        "hide-details": "",
                        color: "primary"
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "tp-plan-link",
                        href: `/teaching-plan/${plan.planId}`,
                        onClick: _withModifiers(($event: any) => (_ctx.openPlan(plan.planId)), ["stop","prevent"])
                      }, _toDisplayString(_ctx.planTypeLabels[plan.planType]), 9, _hoisted_10),
                      (plan.templateName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(plan.templateName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.periodLabel(plan)), 1),
                    _createElementVNode("td", null, _toDisplayString(plan.className || "園全体"), 1),
                    _createElementVNode("td", null, _toDisplayString(plan.authorName), 1),
                    _createElementVNode("td", null, [
                      (plan.deadlineDate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'deadline-alert': _ctx.isDeadlineAlert(plan) })
                            }, _toDisplayString(_ctx.formatDate(plan.deadlineDate)), 3),
                            (_ctx.isDeadlineOverdue(plan))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "期限超過"))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "—"))
                    ]),
                    _createElementVNode("td", null, [
                      (plan.unresolvedCommentCount > 0)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "small",
                            variant: "flat",
                            color: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(plan.unresolvedCommentCount), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "—"))
                    ]),
                    _createElementVNode("td", null, "第" + _toDisplayString(plan.version) + "版", 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "status-badge",
                        style: _normalizeStyle({
                  backgroundColor: _ctx.statusStyles[plan.status].background,
                  color: _ctx.statusStyles[plan.status].color,
                })
                      }, _toDisplayString(_ctx.statusStyles[plan.status].label), 5),
                      (plan.pendingApproverName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(plan.pendingApproverName) + "が承認待ち ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_9))
                }), 128)),
                (_ctx.listResponse.data.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("td", {
                        colspan: "9",
                        class: "text-center text-grey py-6"
                      }, " 該当する指導計画がありません。 ", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.listResponse && _ctx.listResponse.count > _ctx.searchFilters.limit)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 0,
            class: "mt-6",
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page) = $event)),
            length: Math.ceil(_ctx.listResponse.count / _ctx.searchFilters.limit),
            disabled: _ctx.loading,
            "active-color": "primary"
          }, null, 8, ["modelValue", "length", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.createDialog,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.createDialog) = $event)),
      "max-width": "600px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                _createTextVNode("指導計画の新規作成", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                            _createTextVNode("帳票種別", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.createInput.planType,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.createInput.planType) = $event)),
                              items: _ctx.createPlanTypeItems,
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              disabled: _ctx.creating
                            }, null, 8, ["modelValue", "items", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      align: "center",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                            _createTextVNode("年度", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.createInput.businessYear,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.createInput.businessYear) = $event)),
                              items: _ctx.createBusinessYearItems,
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              disabled: _ctx.creating
                            }, null, 8, ["modelValue", "items", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.createInput.planType !== 'overall')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          align: "center",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "4" }, {
                              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                _createTextVNode("クラス", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "8" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.createInput.classId,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.createInput.classId) = $event)),
                                  items: _ctx.createClassItems,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  color: "primary",
                                  disabled: _ctx.creating,
                                  "no-data-text": "担当クラスがありません"
                                }, null, 8, ["modelValue", "items", "disabled"]),
                                (_ctx.createClassItems.length === 0 && _ctx.hasFullClassScope)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.createInput.businessYear) + "年度のクラスがありません。施設設定 > クラス設定で" + _toDisplayString(_ctx.createInput.businessYear) + "年度のクラスを作成してください。 ", 1))
                                  : (_ctx.createClassItems.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.createInput.businessYear) + "年度に担当しているクラスがありません。園の管理者に、職員管理で担任クラスの設定を依頼してください。 ", 1))
                                    : (!_ctx.hasFullClassScope)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 自分が担当しているクラスのみ作成できます。 "))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.createInput.planType === 'monthly')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          align: "center",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "4" }, {
                              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                _createTextVNode("対象月", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "8" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.createInput.month,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.createInput.month) = $event)),
                                  items: _ctx.monthItems,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  suffix: "月",
                                  color: "primary",
                                  disabled: _ctx.creating
                                }, null, 8, ["modelValue", "items", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.createInput.planType === 'weekly')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 2,
                          align: "center",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "4" }, {
                              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                _createTextVNode("対象期間", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "8" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_date_picker, {
                                    modelValue: _ctx.createInput.periodStartDate,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.createInput.periodStartDate) = $event)),
                                    label: "開始日"
                                  }, null, 8, ["modelValue"]),
                                  _cache[43] || (_cache[43] = _createElementVNode("span", { class: "tp-period-range__sep" }, "〜", -1)),
                                  _createVNode(_component_date_picker, {
                                    modelValue: _ctx.createInput.periodEndDate,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.createInput.periodEndDate) = $event)),
                                    label: "終了日"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "text-caption text-grey-darken-1 mt-1" }, " 曜日の制約はありません。開始日と終了日を同じ日にすると日案になります。 ", -1)),
                                (_ctx.periodRangeError)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.periodRangeError), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, {
                      align: "center",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                            _createTextVNode("作成者", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.createInput.authorUserNurseryId,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.createInput.authorUserNurseryId) = $event)),
                              items: _ctx.createAuthorItems,
                              loading: _ctx.loadingAuthors,
                              disabled: _ctx.creating || _ctx.loadingAuthors,
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              "no-data-text": "選択できる職員がいません"
                            }, null, 8, ["modelValue", "items", "loading", "disabled"]),
                            (!_ctx.loadingAuthors && _ctx.createAuthorItems.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 選択できる職員がいません。職員管理で職員を登録してください。 "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_23, " 承認・差戻しの通知は作成者に届きます。 "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      align: "center",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                            _createTextVNode("帳票レイアウト", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.createInput.templateId,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.createInput.templateId) = $event)),
                              items: _ctx.createTemplateItems,
                              loading: _ctx.loadingTemplates,
                              disabled: _ctx.creating || _ctx.loadingTemplates,
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              "no-data-text": "公開済みのレイアウトがありません"
                            }, null, 8, ["modelValue", "items", "loading", "disabled"]),
                            (!_ctx.loadingTemplates && _ctx.createTemplateItems.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.planTypeLabels[_ctx.createInput.planType]) + "に公開済みのレイアウトがありません。帳票設定で公開してください。 ", 1))
                              : (_ctx.hasUnpublishedTemplate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 未公開のレイアウトは選択できません。帳票設定で公開してください。 "))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      align: "center",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("作成方法", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.createInput.carryFromUpper,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.createInput.carryFromUpper) = $event)),
                              label: "上位計画から転記して作成する",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              disabled: _ctx.creating || _ctx.createInput.planType === 'overall'
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createDialog = false)),
                  disabled: _ctx.creating,
                  variant: "text"
                }, {
                  default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                    _createTextVNode(" キャンセル ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.createPlan,
                  loading: _ctx.creating,
                  disabled: !_ctx.canCreate,
                  color: "primary",
                  variant: "flat"
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode(" 作成 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}